/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getWhatsAppTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/whatsapp_templates`);
  }

  createWhatsAppTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/whatsapp_templates`, {
      template,
    });
  }

  deleteWhatsAppTemplate(inboxId, templateName) {
    return axios.delete(
      `${this.url}/${inboxId}/whatsapp_templates/${encodeURIComponent(templateName)}`
    );
  }

  generateQrcode(inboxId) {
    return axios.get(`${this.url}/${inboxId}/generate_qrcode`);
  }

  restartInstance(inboxId) {
    return axios.put(`${this.url}/${inboxId}/restart_instance`);
  }

  getConnectionState(inboxId) {
    return axios.get(`${this.url}/${inboxId}/connection_state`);
  }

  getInstanceSettings(inboxId) {
    return axios.get(`${this.url}/${inboxId}/instance_settings`);
  }

  setInstanceSettings(inboxId, payload) {
    return axios.post(`${this.url}/${inboxId}/set_instance_settings`, payload);
  }

  logoutInstance(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/logout_instance`);
  }

  getServerUrl(inboxId) {
    return axios.get(`${this.url}/${inboxId}/server_url`);
  }
  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }


  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  resetSecret(inboxId) {
    return axios.post(`${this.url}/${inboxId}/reset_secret`);
  }

  enableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/enable_whatsapp_calling`);
  }

  disableWhatsappCalling(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disable_whatsapp_calling`);
  }

  setInboundCalls(inboxId, enabled) {
    return axios.post(`${this.url}/${inboxId}/set_inbound_calls`, {
      inbound_calls_enabled: enabled,
    });
  }
}

export default new Inboxes();
